import { TStoreData } from "../../../../../services/api/instances/vectorStoreApi/types";
import { GenericSelect } from "../../../../../shared/components/AppGenericSelect";

interface Props {
  stores: TStoreData[];
  store: TStoreData | null;
  onSelectStore: (store: TStoreData | null) => void;
  emptyOptionLabel?: string;
  isDisabled?: boolean;
}

export const StoreSelect = (props: Props) => {
  return (
    <GenericSelect<TStoreData>
      options={props.stores}
      value={props.store}
      onChange={props.onSelectStore}
      getLabel={(store) => store.name ?? ""}
      getValue={(store) => store.id}
      emptyOptionLabel={
        props.emptyOptionLabel ? props.emptyOptionLabel : undefined
      }
      isDisabled={props.isDisabled}
      placeholder={"Выберите базу знаний"}
    />
  );
};
